import { ReactNode } from 'react';
import { Navigate, RouteObject } from 'react-router';

interface SetupRoutingBaseProps {
    resourcePath: string;
    editFrame: ReactNode;
    listFrame: ReactNode;
    newFrame?: ReactNode;
}

export function setupModuleRouting(props: SetupRoutingBaseProps): RouteObject {
    return {
        path: props.resourcePath,
        children: [
            {
                path: '',
                element: <Navigate to="list" replace />,
            },
            {
                path: 'list',
                element: props.listFrame,
            },
            {
                path: ':itemId',
                element: props.editFrame,
            },
            {
                path: 'new',
                element: props.newFrame ?? props.editFrame,
            },
        ],
    };
}
